module.exports = __webpack_public_path__ + "img/2025-03-14-01-01.0c30ff5f.png";